import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashNav from "../../Components/DashNav/DashNav";
import Gbtn from "../../Components/buttons/Gbtn";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import AuthorsSVG from "../../Components/SVGS/AuthorsSVG";
import InputField from "../../Components/InputField/InputField";
import { deleteAuthor, postAuthor } from "../../api";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import "animate.css";

function AddRole({ isEdit, isDelete }) {
  const icon = () => {
    return <AuthorsSVG size="26" fill="#DF2F35" />;
  };

  const location = useLocation();
  const authorEdit =
    location.state && location.state ? location.state.authorToEdit : null;
  const page = location.state && location.state ? location.state.page : null;

  let baseUrl = process.env.REACT_APP_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [editImage, setEditImage] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [err, setErr] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [imageErr, setImageErr] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [author, setAuthor] = useState({
    id: authorEdit ? authorEdit.id : 0,
    name: authorEdit ? authorEdit.name : "",
    image_path: authorEdit ? authorEdit.image_path : "",
  });

  // fetching initial data
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setEditImage(authorEdit ? authorEdit.image_path : "");
  }, []);

  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);

  const navigate = useNavigate();

  const saveOnclick = () => {
    setNameErr(false);
    if (author.name === "") setNameErr(true);
    else {
      setIsLoading(true);
      setErr(false);
      let data = new FormData();
      data.append("id", author.id);
      data.append("name", author.name);
      if (typeof profileImage == "string") data.append("image_path", editImage);
      else data.append("image", profileImage, profileImage.name);

      postAuthor(data)
        .then(({ data }) => {
          // console.log("authors response", data);
          setIsLoading(false);
          if (data.success) {
            navigate("/dashboard/authors", {
              state: { page: page },
            });
          } else {
            setErr(true);
            setErrMsg(data.message);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setErr(true);
          if (err.message === "Request failed with status code 400")
            setErrMsg("All Fields Required");
          else setErrMsg(err.message);
          console.log("authors post axios err", err);
        });
    }
  };

  const deleteOnclick = () => {
    setModalIsOpen(true);
  };
  const deleteClick = () => {
    let obj = {
      id: authorEdit ? authorEdit.id : null,
    };
    deleteAuthor(obj)
      .then(({ data }) => {
        setErr(false);
        setIsLoading(true);
        if (data.success) {
          setModalIsOpen(false);
          setIsLoading(false);
          navigate("/dashboard/authors", {
            state: { page: page },
          });
        } else {
          setErr(true);
          setErrMsg(data.message);
        }
      })
      .catch((Err) => {
        console.log("Delete role Error: ", Err);
        setErrMsg(err.message);
        setModalIsOpen(false);
        setErr(true);
        setIsLoading(false);
      });
  };

  const onSelectImage = (img) => {
    if (
      img.type.includes("png") ||
      img.type.includes("jpg") ||
      img.type.includes("jpeg")
    ) {
      setProfileImage(img);
      setImageErr(false);
      setEditImage("");
    } else {
      alert("Invalid File!");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAuthor({ ...author, [name]: value });
  };

  const handleImageErr = () => {
    setImageErr(true);
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        className="deleteModal animate__animated animate__zoomIn"
        style={{ display: "flex" }}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div
              className="delClient-cross"
              onClick={(e) => {
                setModalIsOpen(false);
              }}
            >
              <RxCross2 color="white" size={"20"} />
            </div>
            <>
              <h3 style={{ color: "white", marginBottom: "60px" }}>
                Are you sure you want to delete?
              </h3>

              <Gbtn
                text="Delete"
                color="#EE282E"
                radius="6px"
                width="40%"
                func={deleteClick}
              />
            </>
          </>
        )}
      </Modal>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText={"Authors"} />
        </div>
        <div className="dashPanel" style={{ position: "relative" }}>
          <>
            <div className="ar-dashpanel">
              <h4
                style={{
                  display: err ? "flex" : "none",
                  justifyContent: "center",
                  color: "red",
                  position: "absolute",
                  top: "0",
                  width: "90%",
                }}
              >
                <p>Error! {errMsg}.</p>
              </h4>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <LoadingSpinner />
                </div>
              ) : (
                <div>
                  <div>
                    <div className="ae-formFields">
                      <div className="ae-inputField">
                        <InputField
                          name={"name"}
                          isErr={nameErr}
                          errorMsg="Name is required"
                          required={true}
                          value={authorEdit ? authorEdit.name : null}
                          onChange={(e) => {
                            setNameErr(false);
                            handleChange(e);
                          }}
                          placeholder={"Name"}
                          radius="5px"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="if-txt" style={{ marginTop: "40px" }}>
                    Add Image
                  </div>
                  <div className="Add_Client_Image_container">
                    <label className="changeimage-label">
                      {editImage || profileImage ? (
                        <>
                          <img
                            src={
                              editImage
                                ? baseUrl + editImage
                                : URL.createObjectURL(profileImage)
                            }
                            onError={handleImageErr}
                            alt="cp"
                            height="120px"
                            width="120px"
                            className="add-image-Style"
                          />
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".png, .jpg, jpeg"
                              onChange={(e) => onSelectImage(e.target.files[0])}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <div className="AddimageBtn">
                          <span className="cam_Image_upload">+</span>
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".png, .jpg, jpeg"
                              onChange={(e) => onSelectImage(e.target.files[0])}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </div>
                      )}
                    </label>
                  </div>
                </div>
              )}
              <div className="addEdit-btns">
                <div className="ev-btnAdd ev-btn">
                  <Gbtn
                    text={isEdit ? "Update" : isDelete ? "Delete" : "Add"}
                    func={isDelete ? deleteOnclick : saveOnclick}
                    disabled={isLoading}
                    color="#DF2F35"
                    radius="5px"
                    width="150px"
                  />
                </div>
                <div className="ev-btnDel ev-btn">
                  <Gbtn
                    text={isDelete ? "Back" : "Discard"}
                    color="#0061B1"
                    func={() =>
                      navigate("/dashboard/authors", {
                        state: { page: page },
                      })
                    }
                    radius="5px"
                    width="150px"
                  />
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default AddRole;
